import axios from 'axios';
import { authHeader } from './auth.header';
import config from "../environment/config";
const API_URL = config.API_URL;

export const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

export const formatISODate = (date) => {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${year}-${month}-${day}`;
};

export const getBase64ImageFromUrl = async (imageUrl) => {
  const res = await fetch(imageUrl);
  const blob = await res.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const getDevoteeMasterList = async () => {
  try {
    return (await axios.get(`${API_URL}api/tbldevotees`, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in getDevoteeMasterList():', error);
    throw error;
  }
};

export const getDevoteeMasterData = async (mobileNo) => {
  try {
    const response = await axios.get(`${API_URL}api/tbldevotees/getDevoteeByMobileNo`,
      {
        params: { mobileNo },
        headers: {
          'Content-Type': 'application/json',
          ...authHeader(),
        },
      });
    return response.data;
  } catch (error) {
    console.error('Error occurred in getDevoteeMasterList():', error);
    throw error;
  }
};

export const generateReceipt = async (receiptData) => {
  try {
    return (await axios.post(`${API_URL}api/generateReceipts`, receiptData, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in generateReceipt():', error);
    throw error;
  }
};

export const getReceiptList = async ({ month, year }) => {
  try {
    const response = await axios.get(`${API_URL}api/generateReceipts`,
      {
        params: { month, year },
        headers: {
          'Content-Type': 'application/json',
          ...authHeader(),
        },
      });
    return response.data;
  } catch (error) {
    console.error("Error in getReceiptList():", error);
    throw error;
  }
};


export const getDailyReportList = async (date) => {
  try {
    const response = await axios.get(`${API_URL}api/generateReceipts/dailyReports`,
      {
        params: { date },
        headers: {
          'Content-Type': 'application/json',
          ...authHeader(),
        },
      });
    return response.data;
  } catch (error) {
    console.error("Error in getDailyReportList():", error);
    throw error;
  }
};


export const getDailyPoojaReportList = async (date) => {
  try {
    const response = await axios.get(`${API_URL}api/generateReceipts/dailyPoojaReports`,
      {
        params: { date },
        headers: {
          'Content-Type': 'application/json',
          ...authHeader(),
        },
      });
    return response.data;
  } catch (error) {
    console.error("Error in getDailyPoojaReportList():", error);
    throw error;
  }
};


export const getPeriodicReportList = async (fromdate, todate) => {
  try {
    const response = await axios.get(`${API_URL}api/generateReceipts/periodicReports`,
      {
        params: { fromdate, todate },
        headers: {
          'Content-Type': 'application/json',
          ...authHeader(),
        },
      });
    return response.data;
  } catch (error) {
    console.error("Error in getPeriodicReportList():", error);
    throw error;
  }
};


export const getSevaCollectionReportList = async (date) => {
  try {
    const response = await axios.get(`${API_URL}api/generateReceipts/dailySevaCollection`,
      {
        params: { date },
        headers: {
          'Content-Type': 'application/json',
          ...authHeader(),
        },
      });
    return response.data;
  } catch (error) {
    console.error("Error in getSevaCollectionReportList():", error);
    throw error;
  }
};


export const getDailyCollectionReportList = async (fromdate, todate) => {
  try {
    const response = await axios.get(`${API_URL}api/generateReceipts/dailyCollectionDetails`,
      {
        params: { fromdate, todate },
        headers: {
          'Content-Type': 'application/json',
          ...authHeader(),
        },
      });
    return response.data;
  } catch (error) {
    console.error("Error in getDailyCollectionReportList():", error);
    throw error;
  }
};


export const getSevaWiseReportList = async (fromdate, todate, poojaId) => {
  try {
    const response = await axios.get(`${API_URL}api/generateReceipts/sevaWiseReports`,
      {
        params: { fromdate, todate, poojaId },
        headers: {
          'Content-Type': 'application/json',
          ...authHeader(),
        },
      });
    return response.data;
  } catch (error) {
    console.error("Error in getSevaWiseReportList():", error);
    throw error;
  }
};

export const getDailyExcelReport = async (date) => {
  try {
    const response = await axios.get(`${API_URL}api/generateExcel/dailyExcelReports`,
      {
        params: { date },
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          ...authHeader(),
        },
      });
    return response;
  } catch (error) {
    console.error("Error in getDailyExcelReport():", error);
    throw error;
  }
};


export const getPeriodicExcelReport = async (fromdate, todate) => {
  try {
    const response = await axios.get(`${API_URL}api/generateExcel/periodicExcelReports`,
      {
        params: { fromdate, todate },
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          ...authHeader(),
        },
      });
    return response;
  } catch (error) {
    console.error("Error in getPeriodicReportList():", error);
    throw error;
  }
};

export const getDailyPoojaExcelReport = async (date) => {
  try {
    const response = await axios.get(`${API_URL}api/generateExcel/dailyPoojaExcelReports`,
      {
        params: { date },
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          ...authHeader(),
        },
      });
    return response;
  } catch (error) {
    console.error("Error in getDailyPoojaExcelReport():", error);
    throw error;
  }
};


export const getSevaWiseExcelReport = async (fromdate, todate, poojaId, poojaName) => {
  try {
    const response = await axios.get(`${API_URL}api/generateExcel/sevaWiseExcelReports`,
      {
        params: { fromdate, todate, poojaId, poojaName },
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          ...authHeader(),
        },
      });
    return response;
  } catch (error) {
    console.error("Error in getSevaWiseExcelReport():", error);
    throw error;
  }
};

export const getSevaCollectionExcelReport = async (date) => {
  try {
    const response = await axios.get(`${API_URL}api/generateExcel/sevaCollectionExcelReports`,
      {
        params: { date },
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          ...authHeader(),
        },
      });
    return response;
  } catch (error) {
    console.error("Error in getSevaCollectionExcelReport():", error);
    throw error;
  }
};

export const getCollectionDetailsExcelReport = async (fromdate, todate) => {
  try {
    const response = await axios.get(`${API_URL}api/generateExcel/collectionExcelReports`,
      {
        params: { fromdate, todate },
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          ...authHeader(),
        },
      });
    return response;
  } catch (error) {
    console.error("Error in getCollectionDetailsExcelReport():", error);
    throw error;
  }
};


export const fetchReceiptDetails = async (receiptNo) => {
  try {
    const response = await axios.get(`${API_URL}api/generateReceipts/getReceiptData`,
      {
        params: { receiptNo },
        headers: {
          'Content-Type': 'application/json',
          ...authHeader(),
        },
      });
    return response.data;
  } catch (error) {
    console.error("Error in fetchReceiptDetails():", error);
    throw error;
  }
}

export const cancelReceipt = async (receipId) => {
  try {
    return (await axios.post(`${API_URL}api/generateReceipts/cancelReceipt`, receipId, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in cancelReceipt():', error);
    throw error;
  }
};

export const fetchPrathanaReceiptDetails = async () => {
  try {
    return (await axios.get(`${API_URL}api/tblreceipts/getPrathanaReceipt`, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in fetchPrathanaReceiptDetails():', error);
    throw error;
  }
};

export const getUserReceiptList = async (fromDate, toDate) => {
  try {
    const response = await axios.get(`${API_URL}api/generateReceipts/get-user-receipts`,
      {
        params: { fromDate, toDate },
        headers: {
          'Content-Type': 'application/json',
          ...authHeader(),
        },
      });
    return response.data;
  } catch (error) {
    console.error("Error in getUserReceiptList():", error);
    throw error;
  }
};

export const getPaymentStatus = async (razorpayPaymentId) => {
  try {
    const response = await axios.get(
      `${API_URL}api/generateReceipts/payment-status/${razorpayPaymentId}`,
      { headers: authHeader() }
    );

    return response.data || null;
  } catch (error) {
    console.error('Error occurred in getPaymentStatus', error);
    return null;
  }
};

export const getPaymentDetails = async (razorpayPaymentId) => {
  try {
    const response = await axios.get(
      `${API_URL}api/generateReceipts/payment-details/${razorpayPaymentId}`,
      { headers: authHeader() }
    );

    return response.data || null;
  } catch (error) {
    console.error('Error occurred in getPaymentStatus', error);
    return null;
  }
};

export const savePaymentTransaction = async (paymentData) => {
  try {
    return (await axios.post(`${API_URL}api/paymentTransactions`, paymentData, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in savePaymentTransaction():', error);
    throw error;
  }
};


export const createRazorpayOrder = async (orderData) => {
  try {
    const response = await axios.post(
      `${API_URL}api/generateReceipts/create-order`,
      orderData,
      { headers: { 'Content-Type': 'application/json', ...authHeader() } }
    );
    return response.data;
  } catch (error) {
    console.error('Error occurred in createRazorpayOrder():', error);
    throw error;
  }
};

export const verifyRazorpayPayment = async (verifyData) => {
  try {
    const response = await axios.post(
      `${API_URL}api/generateReceipts/verify-payment`,
      verifyData,
      { headers: { 'Content-Type': 'application/json', ...authHeader() } }
    );
    return response.data;
  } catch (error) {
    console.error('Error occurred in verifyRazorpayPayment():', error);
    throw error;
  }
};
